/**
 * Persistent anonymous ID for guest cart (cookie-based).
 */
export const getAnonymousId = (): string => {
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'anonymousCartId') {
      return decodeURIComponent(value);
    }
  }

  const anonId = crypto.randomUUID
    ? crypto.randomUUID()
    : 'anon-' + Date.now() + '-' + Math.random().toString(36).substring(2, 11);

  const expiryDate = new Date();
  expiryDate.setFullYear(expiryDate.getFullYear() + 1);
  document.cookie = `anonymousCartId=${encodeURIComponent(anonId)}; expires=${expiryDate.toUTCString()}; path=/; SameSite=Lax`;

  return anonId;
};
